import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_test_mode_bar = _resolveComponent("project-test-mode-bar")
  const _component_project_test_mode_filters = _resolveComponent("project-test-mode-filters")
  const _component_project_test_mode_modal = _resolveComponent("project-test-mode-modal")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_project_test_mode_bar, {
      "current-testing-phase": $options.currentTestingPhase,
      "testing-user-groups": $options.testingUserGroups,
      "unpublished-content-visible": $options.isUnpublishedContextVisible,
      "category-names-map": $options.categoryNamesMap,
      onOpenFilters: $options.onOpenFilterDrawer,
      onOpenModal: $options.onModalOpen,
      onCloseTesterMode: $options.closeTesterMode
    }, null, 8 /* PROPS */, ["current-testing-phase", "testing-user-groups", "unpublished-content-visible", "category-names-map", "onOpenFilters", "onOpenModal", "onCloseTesterMode"]),
    _createVNode(_component_project_test_mode_filters, {
      "is-drawer-open": _ctx.isFilterDrawerOpen,
      "user-groups": _ctx.userGroups,
      "original-phase": $options.originalPhase,
      "original-type": $options.originalType,
      "current-testing-phase": $options.currentTestingPhase,
      "project-id": $options.projectId,
      "testing-user-groups": $options.testingUserGroups,
      "is-unpublished-context-visible": $options.isUnpublishedContextVisible,
      "category-names-map": $options.categoryNamesMap,
      "project-url": $props.projectUrl,
      onDrawerClose: $options.onCloseFilterDrawer
    }, null, 8 /* PROPS */, ["is-drawer-open", "user-groups", "original-phase", "original-type", "current-testing-phase", "project-id", "testing-user-groups", "is-unpublished-context-visible", "category-names-map", "project-url", "onDrawerClose"]),
    _createVNode(_component_project_test_mode_modal, {
      "is-modal-visible": _ctx.isModalVisible,
      onClose: $options.onModalClose
    }, null, 8 /* PROPS */, ["is-modal-visible", "onClose"])
  ]))
}